/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, April 17th 2022, 5:20:15 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSActionButton, StyledOSDialog, useToggleState } from "ui-widgets";
import { NotificationTemplateForm } from "./NotificationTemplateForm";
import { Mail } from "react-feather";
import { COLORSCHEME } from "theme/styles";

type NotificationEditButtonProps = Omit<React.ComponentProps<typeof NotificationTemplateForm>, "onSuccessfulAPISave">;

export const NotificationEditButton = ({
  notificationTemplateFetchId,
  notificationTemplateDefaultValues,
  updateNotificationTemplateFromAPICallback,
  notificationIsForHumanTask,
}: NotificationEditButtonProps) => {
  const { handleClose, handleOpen, open } = useToggleState();

  return (
    <>
      <OSActionButton onClick={handleOpen}>Edit</OSActionButton>

      <StyledOSDialog
        popUpIcon={<Mail color={COLORSCHEME.secondaryVariant} />}
        popUpTitle="Notification Template"
        open={open}
        onClose={handleClose}
      >
        <NotificationTemplateForm
          notificationTemplateFetchId={notificationTemplateFetchId}
          notificationTemplateDefaultValues={notificationTemplateDefaultValues}
          updateNotificationTemplateFromAPICallback={updateNotificationTemplateFromAPICallback}
          onSuccessfulAPISave={handleClose}
          notificationIsForHumanTask={notificationIsForHumanTask}
        />
      </StyledOSDialog>
    </>
  );
};
